import { z } from "zod";
import {
  referralTypes,
  serviceTypes,
  serviceUrgencies,
} from "../constants/serviceTypes";
export const contactSchema = z.object({
  name: z
    .string("Zadejte prosím jméno")
    .regex(/^[\wÀ-ž]+ ([\wÀ-ž]+ )*[\wÀ-ž]+$/, "Neplatné jméno"),
  phone: z
    .string("Zadejte prosím telefon")
    .regex(/^(\+\d{1,3} ?)?\d{3} ?\d{3} ?\d{3}$/, "Neplatné tel. číslo"),
  email: z.email("Neplatný email").optional(),
  address: z.string("Zadejte prosím adresu"),
  type: z.union(
    serviceTypes.map((el) => z.literal(el.value)),
    "Vyberte prosím jednu z možností",
  ),
  urgency: z.union(
    serviceUrgencies.map((el) => z.literal(el.value)),
    "Vyberte prosím jednu z možností",
  ),
  message: z.string("Popište nám co se stalo"),
  referral: z.union(referralTypes.map((el) => z.literal(el.value))).optional(),
  validationToken: z.string({ error: "Podvrťe že jste člověk" }),
  images: z.array(
    z.instanceof(File, {
      message: "Please select an image file.",
    }),
  ),
});

export type ContactSchema = z.output<typeof contactSchema>;
